import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import { Col } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import { IChargeBinderList } from 'src/share/types/match';

export interface IChargeBinderListProps {
  suspectId: string;
  chargeBinderList: IChargeBinderList[];
}

const ChargeBinderList = (props: IChargeBinderListProps) => (
  <Row key={`charge-binder-list-${props.suspectId}`}>
    <ul className="binder-list">
      <Col md={12} className="stats-info binder-list-title">
        <h2>Charge Binder List</h2>
      </Col>
      {props.chargeBinderList.map(arrest =>
        <Row className="biometrica-binder-list" key={arrest.id}>
          <Col md={6} className="stats-info">
            <li><p><Label>Charge Id:</Label>{arrest.chargeId || 'Unknown'}</p></li>
            <p><Label>Arrest date:</Label>{arrest.arrestDate || 'Unknown'}</p>
            {arrest.arrestingAgency ? <a href={`https://www.google.com/search?q=${arrest.arrestingAgency.split(' ').join('+')}&num=1`}><p><Label>Arresting agency:</Label>{arrest.arrestingAgency || 'Unknown'}</p></a> : <p><Label>Arresting agency:</Label>{'Unknown'}</p>}
          </Col>
          <Col md={6} className="stats-info">
            <p><Label>Bond amount:</Label>{arrest.bondAmount ? '$' : ''}{arrest.bondAmount || 'Unknown'}</p>
            <p><Label>Crime type:</Label>{arrest.crimeType || 'Unknown'}</p>
            <p><Label>Status:</Label>{arrest.chargeStatus || 'Unknown'}</p>
          </Col>
          <Col md={12} className="stats-info">
            <p><Label>Charge description:</Label>{arrest.chargeDescription || 'Unknown'}</p>
          </Col>
        </Row>
      )}
    </ul>
  </Row>
);

export default ChargeBinderList;